<script lang="ts">
</script>

<div class="herobanner">
  <slot />
</div>

<style>
  .herobanner {
    margin: 4rem 1rem 3rem;
    max-width: 800px;
    width: 100%;
  }
</style>
